// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"2ef96124","516":"2ef96124","622":"2ef96124","642":"2ef96124","846":"2ef96124"}[chunkId] + ".chunk.css";
};